import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { AI_BASE_URL } from "../../lib/aiApiBaseUrl"
import { apiRequest } from "../../lib/request"

export const refreshCache = createAsyncThunk(
  "cacheRefresh/refresh",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiRequest(`${AI_BASE_URL}/cache/refresh`, {
        method: "POST",
      })
      return response
    } catch (error) {
      return rejectWithValue(error?.message || "Cache refresh failed")
    }
  },
)

const cacheRefreshSlice = createSlice({
  name: "cacheRefresh",
  initialState: {
    status: "idle",
    error: null,
  },
  reducers: {
    resetCacheRefresh: (state) => {
      state.status = "idle"
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(refreshCache.pending, (state) => {
        state.status = "loading"
      })
      .addCase(refreshCache.fulfilled, (state) => {
        state.status = "succeeded"
      })
      .addCase(refreshCache.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const { resetCacheRefresh } = cacheRefreshSlice.actions
export default cacheRefreshSlice.reducer
